<div *ngIf="_userProfile" #listDrop>
    <!-- ============================================================== -->
<!-- toggle and nav items -->
<!-- ============================================================== -->
<ul class="navbar-nav float-left mr-auto">
    <li class="nav-item d-none d-md-block">
        <div (click)="toggleSidebar.emit()" id="nav-icon1" class="open">
            <span></span>
            <span></span>
            <span></span>
          </div>
        <!-- <a (click)="toggleSidebar.emit()" class="nav-link sidebartoggler waves-effect waves-light" href="javascript:void(0)">
            <i class="ti-menu"></i>
        </a> -->
    </li>
    <li class="nav-item" style="margin-left:3rem"> 
        <!-- <img class="breadcrumbs-icon" src="../../../assets/logos/2021-logo-ctgfa-square-blue.png" alt="" /> -->
        <div class="breadcrumbs">Ct<span style="margin-left: 5px;">Global</span> <i nz-icon nzType="right" nzTheme="outline"></i> <span>{{ currRoute }}</span></div>
    </li>
</ul>

<div class="proj-version">{{ environment }}</div>

<!-- ============================================================== -->
<!-- Right side toggle and nav items -->
<!-- ============================================================== -->

<ul class="navbar-nav float-right" >

    <li ngbDropdown [formGroup]="navForm">
        <kendo-dropdownlist class="mini" formControlName="client" [data]="roleClients?.Clients" [disabled]="clientDropdownDisable"></kendo-dropdownlist>
    </li>
    
    <li ngbDropdown [formGroup]="navForm" style="margin-right: 3rem;">
        <kendo-dropdownlist #currencyTemplate class="mini" [valuePrimitive]="true" formControlName="currency" [data]="currencyDropDownList" textField="Code" valueField="Id"></kendo-dropdownlist>
    </li>


    <li class="nav-item" ngbDropdown #myLogout="ngbDropdown" [autoClose]="false" placement="bottom-right" (openChange)="openChange($event)">
        
        <a id="idSetting" ngbDropdownToggle class="custom-height text-muted" href="javascript:void(0)" data-toggle="dropdown" aria-haspopup="true"
            aria-expanded="false"><span>{{_userProfile?.FirstName}}</span> <i nz-icon nzType="setting" nzTheme="outline"></i></a>
        
        <div class="dropdown-menu-right user-dd" ngbDropdownMenu *ngIf="load">
            <div class="d-flex no-block align-items-center p-15  m-b-10" >     
                <div class="m-l-10">
                    <h4 class="m-b-0 font-15">{{_userProfile?.FirstName}}</h4>
                    <p class="text-muted m-b-0 font-12">{{_userProfile?.Email}}</p>
                </div>
            </div>

            <a class="custom-dropdown-item"  id="applicationPage"  [href]="applicationUrl"><i nz-icon nzType="appstore" nzTheme="outline"></i> <span>{{userSettings?.Application}}</span></a>
    
            <a >
                <ul class="options" style="margin-left: -25px;">
                    <li *ngFor="let subLayout of userSettings?.SubLayouts">
                        <label for="subLayout.Id"><input type="checkbox"  kendoCheckBox [attr.checked]="subLayout.IsChecked" (change)="changeEvent($event.target.checked, subLayout.Id)" /> {{subLayout.Description}}</label>
                    </li>
                </ul>
            </a>
            <a >
                <ul class="options" style="margin-left: 10px;margin-bottom: 10px;display: none;">
                        <li *ngFor="let subSidebar of userSettings?.SubSideBarTypes">
                            <label for="subSidebar.Code"><input type="radio"  name="sidebar" [value]="subSidebar.Code" (ngModelChange)="changeSideBar(subSidebar.Code)" [(ngModel)]="userSettings.SubSideBarSelected"  (click)="changeSideBar(subSidebar.Code)" /> {{subSidebar.Description}}</label>
                        </li>
                </ul>
            </a>

            <a class="custom-dropdown-item" (click)="showProcess($event, 'general')">
                <i nz-icon nzType="setting" nzTheme="outline"></i> <span>{{userSettings?.GeneralSettings}}</span>
            </a>

            <a  *ngIf="showGeneralSettings">
                <ul class="options">
                    <li>
                        <div>
                            <span><i nz-icon nzType="dollar" nzTheme="outline"></i></span>

                            <nz-select nzShowSearch nzAllowClear [(ngModel)]="userSettings.WebResCurrencySelected" (ngModelChange)="selectionChangeCurrency($event);">
                                <nz-option *ngFor="let list of currencyDropDownList" [nzValue]="list" [nzLabel]="list.Code"></nz-option>
                            </nz-select>
                        </div>
                    </li>
                    <li *ngIf="roleClients?.Role == 'CTGF'">
                        <div>
                            <span><i nz-icon nzType="user" nzTheme="outline"></i></span>

                            <nz-select nzShowSearch nzAllowClear [(ngModel)]="userSettings.WebResClientSelected" (ngModelChange)="selectionChangeClient($event);">
                                <nz-option *ngFor="let list of roleClients?.Clients" [nzValue]="list" [nzLabel]="list"></nz-option>
                            </nz-select>

                        </div>
                    </li>
                    <li *ngIf="roleClients?.Role == 'CTGF'">
                        <div [formGroup]="navForm">

                            <span><i nz-icon nzType="calendar" nzTheme="outline"></i></span>

                            <nz-select nzShowSearch nzAllowClear formControlName="period" (ngModelChange)="selectionChangeHistory($event);$event.stopPropagation()">
                                <nz-option *ngFor="let list of dataHistory" [nzValue]="list.CodeName" [nzLabel]="list.Name"></nz-option>
                            </nz-select>

                        </div>
                    </li>

                    <li *ngFor="let webres of userSettings.WebResSettings">
                        <label for="subSidebar.Code"><input type="radio"  name="sidebar" [value]="webres.Code" (ngModelChange)="webResInvoiceGrid($event,webres.Code)" [(ngModel)]="userSettings.WebResSettingSelected"  (click)="changeWebResSetting(webres.Code)" /> {{webres.Description}}</label>
                    </li>
                </ul>
            </a>
            <a class="custom-dropdown-item" (click)="emailAlert()">
                <i style="font-size: 15px; margin-top: 4px;" class="fa fa-envelope-square"></i> <span>Email Alert</span>
            </a>
            <a *ngIf="roleClients?.Role == 'Carrier'"  class="custom-dropdown-item" (click)="userGuide()">
                <i class="far fa-file-pdf"></i><span>User Guide</span>
            </a>

            <a id="Logout" class="custom-dropdown-item" (click)="logoff()"><i nz-icon nzType="logout" nzTheme="outline"></i> <span>Logout</span></a>
        </div>
    </li>
</ul>

</div>

<kendo-window  title="Email Alerts"  
    *ngIf="isEmailAlert" (close)="closeEmailAlert()"  
    [minWidth]="60" [minHeight]="100"
    [resizable]="true"
    [width]="591" 
    >
    <label>Receive an email with a summary of invoices requiring your action in Web Resolution  
    </label>
    <label>Emails will be sent to your email account  on 
    </label>
    <div class="row" style="margin-left: 1px;margin-top: 25px;">
        <input style="height: 20px; width: 14px;" [(ngModel)]="selectAllEmail" (change)="selectAll()"  type="checkbox"><label style="margin-left: 5px;">Select All</label>
    </div>
    <div class="row" style="margin-left: 1px;">
        <input style="height: 20px; width: 14px;" [(ngModel)]="sunday.isCheck" (change)="onChange(sunday)"  type="checkbox"><label style="margin-left: 5px;">Sunday</label>
        <input style="height: 20px; width: 14px;margin-left: 30px;"  [(ngModel)]="monday.isCheck" (change)="onChange(monday)"  type="checkbox"><label  style="margin-left: 5px;">Monday</label>
        <input style="height: 20px; width: 14px;margin-left: 30px;"  [(ngModel)]="tuesday.isCheck" (change)="onChange(tuesday)"  type="checkbox"><label  style="margin-left: 5px;">Tuesday</label>
        <input style="height: 20px; width: 14px;margin-left: 30px;"  [(ngModel)]="wednesday.isCheck" (change)="onChange(wednesday)"  type="checkbox"><label  style="margin-left: 5px;">Wednesday</label>
    </div>
    <div class="row" style="margin-left: 1px;margin-top: 5px;">
        <input style="height: 20px; width: 14px;" [(ngModel)]="thursday.isCheck" (change)="onChange(thursday)"  type="checkbox"><label style="margin-left: 5px;">Thursday</label>
        <input style="height: 20px; width: 14px;margin-left: 19px;" [(ngModel)]="friday.isCheck" (change)="onChange(friday)"  type="checkbox"><label style="margin-left: 5px;">Friday</label>
        <input style="height: 20px; width: 14px;margin-left: 41px;" [(ngModel)]="saturday.isCheck" (change)="onChange(saturday)"  type="checkbox"><label style="margin-left: 5px;">Saturday</label>
    </div>
    <div style="float: right;">
        <button style="margin: 7px;" type="button"  class="btn btn-info btn-secondary btn-modal-footer-x" (click)="saveEmailAlert()">Save</button>
        <button type="button"  class="btn btn-info btn-secondary btn-modal-footer-x" (click)="closeEmailAlert()">Cancel</button>
      </div>
  </kendo-window>

  <kendo-window  title="User Guide"  
    *ngIf="isUserGuide" (close)="closeUserGuide()"  
    [minWidth]="60" [minHeight]="100"
    [resizable]="true"
    [width]="391" 
    >
    <label style="padding: 10px;">Please select from the User Guides below  
    </label>
    <!-- <ul style="list-style: none;"> -->
        <li style="padding-left: 30px;list-style-type: none;" *ngFor="let guide of userGuideList">
        
            <a><span (click)="openDownload(guide)"  style="text-decoration-line: underline;
                color: #163e70;" >{{guide.Title}}</span></a><br>
            <label style="font-size: small;" for="guide.Id">{{guide.Description}}</label>
        </li>
    <!-- </ul> -->

  </kendo-window>